var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 16.6667H10.8333C15 16.6667 16.6667 15 16.6667 10.8333V5.83333C16.6667 1.66667 15 0 10.8333 0H5.83333C1.66667 0 0 1.66667 0 5.83333V10.8333C0 15 1.66667 16.6667 5.83333 16.6667Z",
    fill: "#007AFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7915 8.33343L7.14984 10.6918L11.8748 5.9751",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.2f17bcc5d1d38a1b0611d8bf3ed6680e.svg";
export { ForwardRef as ReactComponent };